/**
 * DESATIVADO nas rotas: provider ficava no `CompanyLayout` (portal com login).
 * Dashboard admin (`/admin/empresas/:id/dashboard`) segue usando APIs próprias.
 */
import { createContext, useContext, type ReactNode } from 'react';
import { useCompanyPortalDashboardData } from '@/pages/company/dashboard/hooks/useCompanyPortalDashboardData';

export type CompanyPortalDashboardContextValue = ReturnType<
	typeof useCompanyPortalDashboardData
>;

const CompanyPortalDashboardContext =
	createContext<CompanyPortalDashboardContextValue | null>(null);

export function CompanyPortalDashboardProvider({
	children,
}: {
	children: ReactNode;
}) {
	const value = useCompanyPortalDashboardData();

	return (
		<CompanyPortalDashboardContext.Provider value={value}>
			{children}
		</CompanyPortalDashboardContext.Provider>
	);
}

export function useCompanyPortalDashboard(): CompanyPortalDashboardContextValue {
	const ctx = useContext(CompanyPortalDashboardContext);
	if (!ctx) {
		throw new Error(
			'useCompanyPortalDashboard must be used within CompanyPortalDashboardProvider',
		);
	}
	return ctx;
}
